import { OverlayPopupMenu } from 'features/siteView'
import { isNil } from 'lodash'
import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'pages/siteView/siteMap/contexts/FeatureInteractionContext'
import { SiteViewMapProps } from 'pages/siteView/siteMap/SiteViewMap'
import React, { FC } from 'react'

interface MapFeatureDetailsOverlaysContainerProps {
  componentToDisplayOnFeatureClick: SiteViewMapProps['componentToDisplayOnFeatureClick']
}
export const MapFeatureDetailsOverlaysContainer: FC<
  MapFeatureDetailsOverlaysContainerProps
> = (props) => {
  const {
    showFeaturePopupMenu,
    setShowFeaturePopupMenu,
    selectedFeature,
    setSelectedFeature,
  } = useFeatureInteractionContext()

  // Requirements to show a popup menu
  if (
    isNil(selectedFeature) ||
    isNil(showFeaturePopupMenu) ||
    isNil(props.componentToDisplayOnFeatureClick)
  ) {
    return null
  }

  // Is there a popup menu to show
  const popupChild = props.componentToDisplayOnFeatureClick(
    selectedFeature.type === MapFeatureType.Unit ? selectedFeature.unitID : null
  )

  if (popupChild === null) {
    return null
  }

  // Show the popup menu
  return (
    <OverlayPopupMenu
      getDraggableGroup={() => []}
      title={''}
      closeFunction={() => {
        setShowFeaturePopupMenu(undefined)
        setSelectedFeature(undefined)
      }}
      startPosition={showFeaturePopupMenu}>
      {popupChild}
    </OverlayPopupMenu>
  )
}
